"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ApiClient = _interopRequireDefault(require("../ApiClient"));

var _AwaitingValidationOrder = _interopRequireDefault(require("../model/AwaitingValidationOrder"));

var _AwaitingValidationProductOrder = _interopRequireDefault(require("../model/AwaitingValidationProductOrder"));

var _BackendIssue = _interopRequireDefault(require("../model/BackendIssue"));

var _CreateAwaitingValidationProductOrderRequest = _interopRequireDefault(require("../model/CreateAwaitingValidationProductOrderRequest"));

var _Forbidden = _interopRequireDefault(require("../model/Forbidden"));

var _InternalServerError = _interopRequireDefault(require("../model/InternalServerError"));

var _Unauthorized = _interopRequireDefault(require("../model/Unauthorized"));

var _ValidationError = _interopRequireDefault(require("../model/ValidationError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

/**
* AwaitingValidationOrders service.
* @module api/AwaitingValidationOrdersApi
* @version 0.17
*/
var AwaitingValidationOrdersApi = /*#__PURE__*/function () {
  /**
  * Constructs a new AwaitingValidationOrdersApi. 
  * @alias module:api/AwaitingValidationOrdersApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function AwaitingValidationOrdersApi(apiClient) {
    _classCallCheck(this, AwaitingValidationOrdersApi);

    this.apiClient = apiClient || _ApiClient["default"].instance;
  }
  /**
   * Create a new product line into an order which needs to be validated by a Kitchen Manager or Partner
   * **Scopes**: - `awaiting-validation-orders:write`  Add a new product to an existing purchase order which needs to be validated by a Kitchen Manager or Partner. For instance in the case where a product contained within an existing order is tagged as Out of Stock, this endpoint will be used to create a substitute for the unvailable product.
   * @param {String} purchaseUuid 
   * @param {module:model/CreateAwaitingValidationProductOrderRequest} createAwaitingValidationProductOrderRequest 
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationProductOrder} and HTTP response
   */


  _createClass(AwaitingValidationOrdersApi, [{
    key: "createProductOrderForAwaitingValidationOrderWithHttpInfo",
    value: function createProductOrderForAwaitingValidationOrderWithHttpInfo(purchaseUuid, createAwaitingValidationProductOrderRequest) {
      var postBody = createAwaitingValidationProductOrderRequest; // verify the required parameter 'purchaseUuid' is set

      if (purchaseUuid === undefined || purchaseUuid === null) {
        throw new Error("Missing the required parameter 'purchaseUuid' when calling createProductOrderForAwaitingValidationOrder");
      } // verify the required parameter 'createAwaitingValidationProductOrderRequest' is set


      if (createAwaitingValidationProductOrderRequest === undefined || createAwaitingValidationProductOrderRequest === null) {
        throw new Error("Missing the required parameter 'createAwaitingValidationProductOrderRequest' when calling createProductOrderForAwaitingValidationOrder");
      }

      var pathParams = {
        'purchase_uuid': purchaseUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = ['application/json'];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationProductOrder["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_uuid}/products', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Create a new product line into an order which needs to be validated by a Kitchen Manager or Partner
     * **Scopes**: - `awaiting-validation-orders:write`  Add a new product to an existing purchase order which needs to be validated by a Kitchen Manager or Partner. For instance in the case where a product contained within an existing order is tagged as Out of Stock, this endpoint will be used to create a substitute for the unvailable product.
     * @param {String} purchaseUuid 
     * @param {module:model/CreateAwaitingValidationProductOrderRequest} createAwaitingValidationProductOrderRequest 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationProductOrder}
     */

  }, {
    key: "createProductOrderForAwaitingValidationOrder",
    value: function createProductOrderForAwaitingValidationOrder(purchaseUuid, createAwaitingValidationProductOrderRequest) {
      return this.createProductOrderForAwaitingValidationOrderWithHttpInfo(purchaseUuid, createAwaitingValidationProductOrderRequest).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
    /**
     * Retrieve a purchase order which needs to be validated by a Kitchen Manager or Partner
     * **Scopes:** - `awaiting-delivery-orders:read` - `awaiting-validation-orders:read` - `daily-consumption-before-inventories:read` - `daily-product-consumptions:read` - `inventories:read` - `purchase-orders:read` - `validated-orders:read`  Retrieve a purchase order which in state *AWAITING_VALIDATION* from `purchases-manager` API.  With the data retrieved from this API, we'll also append supply-related data of the product found on `products-manager` API (e.g. the product labels, etc…) with its estimated needs for the current order and the current product's stock within the kitchen doing the order.
     * @param {String} purchaseUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link module:model/AwaitingValidationOrder} and HTTP response
     */

  }, {
    key: "getAwaitingValidationOrdersWithHttpInfo",
    value: function getAwaitingValidationOrdersWithHttpInfo(purchaseUuid) {
      var postBody = null; // verify the required parameter 'purchaseUuid' is set

      if (purchaseUuid === undefined || purchaseUuid === null) {
        throw new Error("Missing the required parameter 'purchaseUuid' when calling getAwaitingValidationOrders");
      }

      var pathParams = {
        'purchase_uuid': purchaseUuid
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['OAuth2'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = _AwaitingValidationOrder["default"];
      return this.apiClient.callApi('/awaiting-validation-orders/{purchase_uuid}', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }
    /**
     * Retrieve a purchase order which needs to be validated by a Kitchen Manager or Partner
     * **Scopes:** - `awaiting-delivery-orders:read` - `awaiting-validation-orders:read` - `daily-consumption-before-inventories:read` - `daily-product-consumptions:read` - `inventories:read` - `purchase-orders:read` - `validated-orders:read`  Retrieve a purchase order which in state *AWAITING_VALIDATION* from `purchases-manager` API.  With the data retrieved from this API, we'll also append supply-related data of the product found on `products-manager` API (e.g. the product labels, etc…) with its estimated needs for the current order and the current product's stock within the kitchen doing the order.
     * @param {String} purchaseUuid 
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link module:model/AwaitingValidationOrder}
     */

  }, {
    key: "getAwaitingValidationOrders",
    value: function getAwaitingValidationOrders(purchaseUuid) {
      return this.getAwaitingValidationOrdersWithHttpInfo(purchaseUuid).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);

  return AwaitingValidationOrdersApi;
}();

exports["default"] = AwaitingValidationOrdersApi;